import { Injectable } from '@angular/core';
import { collection, doc, Firestore, query, limit, orderBy, where, getDoc, getDocs, startAfter, endBefore, limitToLast, serverTimestamp, setDoc, updateDoc, deleteDoc } from '@angular/fire/firestore';
import { HelperService } from './helper.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AccessesService {
  accesses : any;
  accessQuizId: any;
  constructor(public firestore: Firestore, 
    private helperService: HelperService,
    private userService: UserService) { }

  public setAccessesList(v : any) {
    this.accesses = v;
  }

  public getAccessesList() {
    return this.accesses;
  }

  getAccessDetails(quizId:string, email:string, type:any) {
    return new Promise((resolve, reject) => {
      let accessQueryRef;
      if (type == 'p')
        accessQueryRef = query(collection(this.firestore, 'accesses'), where('pollId', '==', quizId), where('isDeleted', "==", false), where('sharedUserEmail', "==", email))
      else
        accessQueryRef = query(collection(this.firestore, 'accesses'), where('quizId', '==', quizId), where('isDeleted', "==", false), where('sharedUserEmail', "==", email))
      let accessList:any = []
      getDocs(accessQueryRef).then((docs) => {
        docs.forEach((doc: any) => {
          var q = doc.data();
          q['id'] = doc.id;
          accessList.push(q);
        });
        resolve(accessList)
      }).catch(err => {
        reject(accessList)
      })
    })
  }

//quiz/poll accesses hard delete from accesses collection
  hardDeleteQuizAccesses(quizId:any,poll:any=null){
    return new Promise((resolve, reject) => {
      let quizRef = collection(this.firestore,'accesses')
      let queryRef:any ;
      if(quizId && poll==null){
        queryRef = query(quizRef,where('quizId', '==', quizId));
      }
      //quizId = pollId
      if(quizId && poll){
        queryRef = query(quizRef,where('pollId', '==', quizId));
      }
      getDocs(queryRef).then((result:any) => {
        if(result){
          result.forEach((element:any) => {
            deleteDoc(doc(quizRef,element.id))
          });
        resolve(false)
        }
      }).catch((err=>{
        reject(err);
      }))
    })
  }

  getAccessList(email:string, accesses:any) {
    return new Promise((resolve, reject) => {
      let userData = this.userService.getUser()
      let accessRef = collection(this.firestore, 'accesses')
      let queryRef = null;
      if(accesses && accesses.length){
        var lastDoc = accesses[accesses.length-1];
        queryRef = query(accessRef, where('sharedUserEmail', '==', email),where('creatorId', '!=', userData.uid), where("isDeleted","==",false),orderBy('creatorId'),orderBy('sharedDate','desc'), startAfter(lastDoc['sharedDate']));
      }
      else{
        queryRef = query(accessRef, where('sharedUserEmail', '==', email),where('creatorId', '!=', userData.uid), where("isDeleted","==",false),orderBy('creatorId'),orderBy('sharedDate','desc'),);
      }
      getDocs(queryRef).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  async createQuizOwnerFirstAccess(quiz:any) {
    let user = this.userService.getUser()
    let contentRef = this.userService.getUserContentRef()
    let access:any = {
      'id': quiz.quizId ?? quiz.pollId,
      'creatorId': user.uid,
      'sharedUserId': user.uid,
      'sharedUserEmail': user.email,
      'accessType': 'Owner',
      'contentId': contentRef.contentId,
      'isDeleted': false,
      'sharedDate': serverTimestamp(),
    }
    if(quiz.quizId)
      access.quizId = quiz.quizId
    if(quiz.pollId)
      access.pollId = quiz.pollId
    let accessRef = doc(this.firestore,'accesses', access.id);
    await setDoc(accessRef, access)
    return;
  }

  //get shared access list
  getSharedByYouList(accesses:any) {
    return new Promise((resolve, reject) => {
      let userData = this.userService.getUser()
      let accessRef = collection(this.firestore, 'accesses')
      let queryRef = null;
      if(accesses && accesses.length){
        var lastDoc = accesses[accesses.length-1];
        queryRef = query(accessRef, where('sharedUserId', '!=', userData.uid),where('creatorId', '==', userData.uid), where("isDeleted","==",false),orderBy('sharedUserId'),orderBy('sharedDate','desc'), startAfter(lastDoc['sharedDate']));
      }
      else{
        queryRef = query(accessRef, where('sharedUserId', '!=', userData.uid),where('creatorId', '==', userData.uid), where("isDeleted","==",false),orderBy('sharedUserId'),orderBy('sharedDate','desc'),);
      }
      getDocs(queryRef).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  //get access details by id 
  getAccessDetailsById(accessId:string) {
    return new Promise(async (resolve, reject) => {
      let accessQueryRef = query(collection(this.firestore, 'accesses'), where('id', '==', accessId))
      let accessData:any;
      await getDocs(accessQueryRef).then((docs) => {
        docs.forEach((doc: any) => {
          accessData = doc.data();
        });
        resolve(accessData)
      }).catch(err => {
        reject(accessData)
      })
    })
  }
  
  //get all access list that contains array of quiz ids 
  async getAllAccessList(){
    let accessesQuizId:any=[]
    let currentUser = this.userService.getUser()
    var email=currentUser.email;
    let accessesList:any = []
    accessesList = this.getAccessesList();
    if(!accessesList){
      accessesList = []
      await this.getAccessList(email, accessesList).then((results:any) => {
        results.forEach((doc:any) => {
          let access = doc.data()
          accessesList.push(access) //taking the snapshot of the current accesses data
          });
          this.setAccessesList(accessesList)
      })
    }
    if(accessesList){
      accessesList.forEach((element:any) => {
        accessesQuizId.push(element.quizId)
      });
    }
    this.setAccessQuizIds(accessesQuizId)
    return accessesQuizId
   }

  public setAccessQuizIds(v : any) {
    this.accessQuizId = v;
  }

  public getAccessQuizIds() {
   return  this.accessQuizId
  }

  //get access details by quizId
  getAccessDetailsByQuizId(quizId:string) {
    return new Promise(async (resolve, reject) => {
      let accessQueryRef = query(collection(this.firestore, 'accesses'), where('quizId', '==', quizId), where('isDeleted', '==', false))
      let accessData:any = [];
      await getDocs(accessQueryRef).then((docs) => {
        docs.forEach((doc: any) => {
          accessData.push(doc.data());
        });
        resolve(accessData)
      }).catch(err => {
        reject(accessData)
      })
    })
  }
  
  ///getting creator id for  autocomplete feature ---

  getAceData(creatorID:any){
    let userData:any=[];
    return new Promise<void>((resolve, reject) => {
      let queryRef = query(collection(this.firestore, 'accesses'),  where('creatorId', "==", creatorID),where('sharedUserId',"!=",creatorID))
	 
	    getDocs(queryRef).then((result:any)=>{
			  result.forEach((doc:any)=>{
				  let email= doc.data();
				  userData.push(email['sharedUserEmail']);
			  })
	    })
      resolve(userData)
    })
  }

  // add new access
  addNewAccess(addNewAccessObj:any) {
    return new Promise(async (resolve,reject)=>{
      let access:any = {
        ...addNewAccessObj,
        id:this.helperService.uuidv4()
      }

      let accessRef = doc(this.firestore,'accesses', access.id);
      setDoc(accessRef, access).then(result => {
        resolve(true)
      }).catch(err=>{
          reject(err)
      })
    })
  }
  //update access
  updateAccess(updateAccessObj:any) {
    return new Promise(async (resolve,reject)=>{
      let accessRef = doc(this.firestore,'accesses', updateAccessObj.id);
      await updateDoc(accessRef, updateAccessObj).then(result => {
        resolve(true)
      }).catch(err=>{
          reject(err)
      })
    })
  }

  // moving quiz for collaborator (share) access
  movingQuiz_(quizDetails:any){
    return new Promise((resolve, reject) => {
      if (quizDetails && quizDetails.quizId) {
        let projectRef = doc(this.firestore,'contentAccountMapping', quizDetails.refContentId, 'quiz', quizDetails.quizId);
        setDoc(projectRef, quizDetails).then((result) => {
          resolve(quizDetails);
        }).catch((err) => {
          reject(err);
        });
      } else {
        resolve(true)
      }
    })
  }
  // moving quiz settings for collaborator (share) access
  movingQuizSettings(quizSettingDetails:any){
    return new Promise((resolve, reject) => {
      if (quizSettingDetails && quizSettingDetails.settingId) {
        let projectRef = doc(this.firestore,'setting', quizSettingDetails.settingId);
        setDoc(projectRef, quizSettingDetails).then((result) => {
          resolve(quizSettingDetails);
        }).catch((err) => {
          reject(err);
        });
      } else {
        resolve(true)
      }
    })
  }
  // moving questions for collaborator (share) access
  movingQuestions(_listOfQuestions:any,quizId:any,contentId:any){
    return new Promise((resolve, reject) => {
      if (_listOfQuestions.length > 0) {
        _listOfQuestions.forEach((element:any,index:any) => {
          let projectRef = doc(this.firestore,'contentAccountMapping', contentId, 'quiz', quizId, 'question',element.questionId);
          setDoc(projectRef, element).then((result) => {
            if(index+1 == _listOfQuestions.length)
              resolve(true);
          }).catch((err) => {
            reject(err);
          });
        })
      } else {
        resolve(true)
      }
    })
  }

  //check access by contentId creatorId quizid and emailid
  checkAccessByQuizIdAndEmailId(project:any,emailId:any) {
    return new Promise(async (resolve, reject) => {
      let accessQueryRef = query(collection(this.firestore, 'accesses'),where('contentId', '==', project.refContentId),where('creatorId', '==', project.createdBy), where('sharedUserEmail', '==', emailId), where('quizId', '==', project.quizId), where('isDeleted', '==', false),limit(1))
      let accessData:any;
      await getDocs(accessQueryRef).then((docs) => {
        docs.forEach((doc: any) => {
          accessData = doc.data();
        });
        resolve(accessData)
      }).catch(err => {
        reject(accessData)
      })
    })
  }

}
